import { useModals } from 'almanac-ui/Modal'
import { Download } from 'blaze-ui/icons'
import { DesignDownloadModal } from 'components/DesignDownloadModal/DesignDownloadModal'
import { MobileButton } from 'components/MobileButton/MobileButton'
import { usePostPreviewContext } from 'components/PostPreviewModal/PostPreviewContext'

export const DownloadButton = () => {
  const { openModal } = useModals()

  const { fileId } = usePostPreviewContext()

  return (
    <MobileButton
      variant="tertiary"
      icon={Download}
      size="sm"
      onPress={() => {
        openModal(
          DesignDownloadModal,
          {
            fileId,
          },
          { newStack: true },
        )
      }}
    >
      Download
    </MobileButton>
  )
}
